import React from "react";
import {connect} from 'react-redux'
import selectors from "../../../redux/selectors";
import {IAppState} from "../../../redux/store";
import IUser from "../../../model/interface/security/IUser";
import UsersService from "../../../model/service/security/UsersService";
import {reLoad, startLoading} from "../../../redux/actions/Setup";
import {Dropdown, Menu, Tooltip} from "antd";
import CountryFlag from "../../shared/display/CountryFlag";
import {CheckOutlined} from "@ant-design/icons";
import ILanguage from "../../../model/interface/ui/dictionary/ILanguage";

interface IProps {
    getText: (code: string, fallBack?: string) => string
    user: IUser
    reLoad: () => void
    startLoading: () => void
    languages: ILanguage[]
}

interface IState {
    modalVisible: boolean
}

class NavLanguage extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {
            modalVisible: false
        }
    }

    setLanguage = (language: string) => {
        const {user, reLoad, startLoading} = this.props
        if (user.language !== language) {
            startLoading()
            UsersService.resourceUpdate(user.uuid, {language}).then(() => {
                reLoad()
            })
        }
    }

    render() {
        const {languages, user} = this.props
        const current = languages.find(l => l.uuid === user.language)

        return (
            <Dropdown placement="bottomRight" overlay={<Menu>
                {
                    languages.map((language, i) => {
                        return (
                            <Menu.Item
                                key={i}
                                className={user.language === language.uuid ? 'ant-dropdown-menu-item-active' : ''}
                                onClick={() => this.setLanguage(language.uuid)}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        {language.icon ?
                                            <CountryFlag className={'mr-1'} tooltip={false}
                                                         countryCode={language.icon}/>
                                            : ''} {language.label + ' [' + language.code + ']'}
                                    </div>
                                    {user.language === language.uuid ?
                                        <CheckOutlined className="ml-2 text-success"/> : null}
                                </div>
                            </Menu.Item>
                        )
                    })
                }
            </Menu>} trigger={["click"]}>
                <div className={'nav-icon'}>
                    {current && (
                        <div className={'d-flex'} style={{fontSize: 16}}>
                            {current.icon ? <Tooltip title={current.label}>
                                <CountryFlag tooltip={false} countryCode={current.icon}/>
                            </Tooltip> : ''}
                        </div>
                    )}
                </div>
            </Dropdown>
        )
    }
}


const mapStateToProps = (state: IAppState) => {
    return {
        languages: state.setup.languages,
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback),
        user: state.setup.user
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        reLoad: () => dispatch(reLoad()),
        startLoading: () => dispatch(startLoading())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavLanguage)
